import { Injectable } from "@angular/core";
import { daysFromNow } from "@helpers/date";
import { Helper } from "@helpers/functions";
import { Observable, Subject } from "rxjs";
import { filter, map, share, startWith } from "rxjs/operators";

@Injectable({
	providedIn: "root"
})
export class BannerCardDismissService {
	private readonly refreshIsDismissed: Subject<string> = new Subject<string>();

	public dismissForCurrentUser(bannerKey: string, storeDays: number): void {
		const expirationDate = daysFromNow(storeDays);
		this.saveIsDismissedForCurrentUser(this.getStorageKey(bannerKey), true, expirationDate);
		this.refreshIsDismissed.next(bannerKey);
	}

	public getIsShowingForCurrentUser$(bannerKey: string): Observable<boolean> {
		const result = this.refreshIsDismissed.pipe(
			startWith(bannerKey),
			filter((cookieKey) => cookieKey === bannerKey),
			map((_) => !this.loadIsDismissedForCurrentUser(this.getStorageKey(bannerKey))),
			share()
		);
		return result;
	}

	private getStorageKey(bannerKey: string): string {
		return `${bannerKey}-dismissed`;
	}

	private saveIsDismissedForCurrentUser(cookieKey: string, value: boolean, expirationDate: Date): void {
		const addPidToDismissOnlyForCurrentUser = true;
		Helper.setCookie(
			cookieKey,
			value.toString(),
			addPidToDismissOnlyForCurrentUser,
			false,
			true,
			true,
			expirationDate
		);
		this.refreshIsDismissed.next(cookieKey);
	}

	private loadIsDismissedForCurrentUser(cookieKey: string): boolean {
		return Helper.getCookie(cookieKey) === true.toString();
	}
}
